import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PurgeImageQuestionsBar = ({ token, isAr, onDone }) => {
  const [count, setCount] = useState(null);
  const [busy, setBusy] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => axios.get(`${API_URL}/api/admin/questions/b-with-images/count`, { headers }).then((r) => setCount(r.data.count)).catch(() => {});
  useEffect(() => { load(); }, [token]);

  if (!count) return null;

  const run = async () => {
    const word = isAr ? 'احذف' : 'RADERA';
    const typed = window.prompt(isAr
      ? `سيتم حذف ${count} سؤال B قديم فيه صورة نهائياً ولا يمكن استرجاعها. القسم المخفي والتاكسي لن يتأثرا.\nاكتب "${word}" للتأكيد:`
      : `${count} gamla B-frågor med bild raderas permanent. Dolda frågor och taxi påverkas inte.\nSkriv "${word}" för att bekräfta:`);
    if ((typed || '').trim() !== word) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/admin/questions/b-with-images/delete`, { confirm: 'DELETE' }, { headers });
      toast.success(isAr ? `تم حذف ${data.deleted} سؤال` : `${data.deleted} frågor raderade`);
      setCount(0);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error');
    } finally { setBusy(false); }
  };

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-rose-200 bg-rose-50 p-3" data-testid="purge-image-questions-bar">
      <p className="flex-1 min-w-[200px] text-sm text-rose-800">
        {isAr ? `أسئلة B القديمة التي فيها صور: ${count}` : `Gamla B-frågor med bild: ${count}`}
      </p>
      <Button size="sm" onClick={run} disabled={busy} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="purge-image-questions-btn">
        {busy ? <Loader2 className="w-4 h-4 me-2 animate-spin" /> : <Trash2 className="w-4 h-4 me-2" />}
        {isAr ? 'حذف كل الأسئلة التي فيها صور' : 'Radera alla frågor med bild'}
      </Button>
    </div>
  );
};
